import { Checkbox, Popover } from 'antd';
import React, { useState } from 'react';

const CustomCheckboxSelection = ({
  checked,
  indeterminate,
  disabled,
  onSelectAllPage,
  onSelectAllAcross,
  currentPageCount,
  totalCount,
  isSelectAllAcrossPages,
  selectedCount,
  onDeselectAll,
}) => {
  const [popoverVisible, setPopoverVisible] = useState(false);

  const isPageSelected =
    !isSelectAllAcrossPages &&
    selectedCount === currentPageCount &&
    currentPageCount > 0;

  const hasMultiplePages = totalCount > currentPageCount;

  const handleCheckboxClick = (e) => {
    e.stopPropagation();

    // If checkbox is already selected (either page or cross-page), deselect it
    if (isPageSelected || isSelectAllAcrossPages) {
      setPopoverVisible(false);
      if (onDeselectAll) {
        onDeselectAll();
      }
      return;
    }

    // If not selected and not disabled
    if (!disabled) {
      // If all data fits on one page, directly select all without showing popover
      if (!hasMultiplePages) {
        if (onSelectAllPage) {
          onSelectAllPage();
        }
      } else {
        // If there are multiple pages, show the popover
        setPopoverVisible(!popoverVisible);
      }
    }
  };

  const handleOptionClick = (callback) => {
    callback();
    setPopoverVisible(false);
  };

  const content = (
    <div className="custom-selection-options">
      <div
        className="selection-option"
        onClick={() => handleOptionClick(onSelectAllPage)}
      >
        <span className={`option-icon ${isPageSelected ? 'has-check' : ''}`}>
          {isPageSelected ? '✓' : ''}
        </span>
        <span className="option-text">Select all on this page</span>
        <span className="option-count">{currentPageCount || 0}</span>
      </div>
      {hasMultiplePages && (
        <div
          className="selection-option"
          onClick={() => handleOptionClick(onSelectAllAcross)}
        >
          <span
            className={`option-icon ${isSelectAllAcrossPages ? 'has-check' : ''}`}
          >
            {isSelectAllAcrossPages ? '✓' : ''}
          </span>
          <span className="option-text">Select all across pages</span>
          <span className="option-count">{totalCount || 0}</span>
        </div>
      )}
    </div>
  );

  return (
    <Popover
      content={content}
      trigger={isPageSelected || isSelectAllAcrossPages ? [] : ['click']}
      placement="bottomLeft"
      open={popoverVisible}
      onOpenChange={(visible) => {
        // Only allow popover to open if not already selected and has multiple pages
        if (visible && (isPageSelected || isSelectAllAcrossPages || !hasMultiplePages)) {
          return;
        }
        setPopoverVisible(visible);
      }}
      classNames={{
        root: 'custom-checkbox-selection-popover',
        container: 'custom-checkbox-selection-popover-container',
      }}
    >
      <Checkbox
        checked={checked}
        indeterminate={indeterminate}
        disabled={disabled}
        onClick={handleCheckboxClick}
        className="custom-selection-checkbox"
      />
    </Popover>
  );
};

export default CustomCheckboxSelection;
